<template>

  <component :is="tabContent(itemDetail.tradeKind)" :item-detail="itemDetail" />
</template>

<script>
import TabContentA from '@/views/public_0983cc/project/detail/public/TabContent.vue'
import TabContentB from '@/views/public_0983cc/project/detail/smallmicro/TabContent.vue'
export default {
  components: {
    TabContentA,
    TabContentB
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    tabContent() {
      return function(tradeKind) {
        switch (tradeKind) {
          case 'smallmicro':return 'TabContentB'
          default : return 'TabContentA'
        }
      }
    }
  }
}
</script>

<style>

</style>
